// extracted by mini-css-extract-plugin
module.exports = {"recent":"RecentSearches_recent__3Ghhl","link":"RecentSearches_link__1XUDj","clear":"RecentSearches_clear__1-wkl"};